// src/pages/Returns.jsx
import React from "react";

// קומפוננטת עמוד "מדיניות החזרות וביטולים"
export default function Returns() {
  const lastUpdated = new Date().toLocaleDateString("he-IL");

  return (
    <main dir="rtl" lang="he" className="nfig-legal my-10 space-y-6">
      <header className="space-y-1">
        <h1 className="text-3xl font-bold">מדיניות החזרות וביטולים</h1>
        <p className="text-sm text-gray-500">תאריך עדכון אחרון: {lastUpdated}</p>
      </header>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">1. החזרת מוצרים</h2>
        <p>
          ניתן להחזיר מוצר חדש וסגור באריזתו המקורית תוך{" "}
          <strong>14 יום ממועד קבלת המוצר</strong>, בצירוף חשבונית/הוכחת רכישה.
        </p>
        <p>מוצר שהקופסה שלו נפתחה לא ניתן להחזיר אלא אם נמצא בו פגם יצרני.</p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">2. פגמים יצרניים</h2>
        <p>
          במידה והמוצר התקבל פגום או לא תקין, יש ליצור קשר עם שירות הלקוחות תוך{" "}
          <strong>48 שעות</strong> מקבלת המשלוח. נשמח להציע החזר כספי מלא או
          החלפה למוצר תקין, בכפוף להחזרת המוצר הפגום באריזתו המקורית.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">3. ביטול עסקה</h2>
        <p>
          ניתן לבטל עסקה שבוצעה באתר בהתאם לחוק הגנת הצרכן, תשמ״א-1981.
          ביטול יתאפשר תוך 14 ימים מיום קבלת המוצר או מיום קבלת מסמך העסקה
          (המאוחר מביניהם).
        </p>
        <p>
          במקרה של ביטול עסקה מסיבה שאינה פגם במוצר, ייגבו{" "}
          <strong>דמי ביטול בשיעור של עד 5% ממחיר העסקה או ‎100 ₪</strong>,
          הנמוך מביניהם.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">4. הוצאות משלוח</h2>
        <p>
          דמי המשלוח ששולמו בעת הרכישה אינם ניתנים להחזר, אלא אם ההחזרה בוצעה
          עקב טעות שלנו או פגם יצרני.
        </p>
        <p>
          עלות החזרת המוצר חלה על הלקוח, למעט במקרה של מוצר פגום או טעות
          באספקה.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">5. אופן ההחזר</h2>
        <p>
          ההחזר יבוצע לאמצעי התשלום שבו בוצעה העסקה תוך{" "}
          <strong>14 ימי עסקים</strong> ממועד קבלת המוצר חזרה ובדיקתו במחסננו.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-xl font-semibold">6. יצירת קשר</h2>
        <address className="not-italic">
          לכל שאלה או בקשה בנוגע להחזרות וביטולים:{" "}
          <a
            className="text-blue-700 underline"
            href="mailto:example@yourshop.com"
          >
            example@yourshop.com
          </a>{" "}
          | טל׳: <strong>[מספר]</strong>
        </address>
      </section>
    </main>
  );
}
